import { Component, HostListener, inject } from '@angular/core';
import { ConfirmService } from '../../../core/services/confirm.service';
import { IconComponent } from '../../icon/icon.component';

/** Modal of ConfirmService (placed once in the app root). */
@Component({
  selector: 'pp-confirm-dialog',
  standalone: true,
  imports: [IconComponent],
  template: `
    @if (confirm.pending(); as q) {
      <div class="fixed inset-0 z-[60] flex items-center justify-center bg-ink-primary/40 px-4" (click)="confirm.answer(false)">
        <div class="w-full max-w-sm rounded-lg bg-surface shadow-flyout" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
          <div class="flex items-start gap-3 px-5 pt-5">
            <span
              class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
              [class]="q.danger ? 'bg-status-danger/10 text-status-danger' : 'bg-action/10 text-action'"
            >
              <pp-icon [name]="q.danger ? 'trash' : 'info'" [size]="15"></pp-icon>
            </span>
            <div class="min-w-0">
              <h2 class="text-card-title text-ink-primary">{{ q.title }}</h2>
              @if (q.message) {
                <p class="mt-1 text-[13px] text-ink-secondary leading-5">{{ q.message }}</p>
              }
            </div>
          </div>
          <div class="mt-5 flex items-center justify-end gap-2 border-t border-border-subtle px-5 py-3">
            <button type="button" (click)="confirm.answer(false)" class="rounded-md border border-border px-3.5 py-1.5 text-[13px] font-medium text-ink-secondary hover:bg-surface-canvas transition-colors">
              Cancel
            </button>
            <button
              type="button"
              autofocus
              (click)="confirm.answer(true)"
              class="rounded-md px-3.5 py-1.5 text-[13px] font-semibold text-white transition-colors"
              [class]="q.danger ? 'bg-status-danger hover:bg-status-danger/90' : 'bg-action hover:bg-action/90'"
            >
              {{ q.confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class ConfirmDialogComponent {
  protected readonly confirm = inject(ConfirmService);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.confirm.answer(false);
  }
}
